import React, { useState, useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/service.css";
import Button from "../components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import banner from "../assets/b1.jpg";
import peie from "../assets/peie.png";
import {
  getParametersRequest,
  trainRequest,
  trainStatusRequest,
  testRequest,
  testStatusRequest
} from "../services/trademasterService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Buffer } from "buffer";
export default function Service({
  sessionID,
  setSessionID,
  optionSelected,
  setOptionSelected,
  getDateStrFromDate
}) {
  const [trainBtnDisabled, setTrainBtnDisabled] = useState(false);
  const [requestTrainOutput, setRequestTrainOutput] = useState("");
  const [requestTestOutput, setRequestTestOutput] = useState("");
  const [task, setTask] = useState("algorithmic_trading");
  const [dataset, setDataset] = useState("");
  const [agent, setAgent] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [optimizerName, setOptimizerName] = useState("Adam");
  const [lossName, setLossName] = useState("MSE");
  const [autoFillData, setAutoFillData] = useState();
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());
  const [figure1Base64String, setFigure1Base64String] = useState("");
  const [figure1Url, setFigure1Url] = useState("");
  const [figure2Base64String, setFigure2Base64String] = useState("");
  const [figure2Url, setFigure2Url] = useState("");

  const navigate = useNavigate();

  function getDateStrFromDate(date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    let str = year + "-" + month + "-" + day;
    return str;
  }

  useEffect(() => {
    if (figure1Base64String) {
      //convert base64 to utf8array, then to Blob
      const byteString = Buffer.from(figure1Base64String, "base64");
      const blob = new Blob([byteString.buffer]);
      const url = URL.createObjectURL(blob);

      // Set the URL as the imageUrl state variable
      setFigure1Url(url);
    }
  }, [figure1Base64String]);

  useEffect(() => {
    if (figure2Base64String) {
      //convert base64 to utf8array, then to Blob
      const byteString = Buffer.from(figure2Base64String, "base64");
      const blob = new Blob([byteString.buffer]);
      const url = URL.createObjectURL(blob);

      // Set the URL as the imageUrl state variable
      setFigure2Url(url);
    }
  }, [figure2Base64String]);

  useEffect(() => {
    let temp = optionSelected;
    temp.task_name = task;
    temp.dataset_name = dataset;
    temp.agent_name = agent;

    setOptionSelected(temp);

    let promise = getParametersRequest();
    promise.then((res) => {
      console.log(res);
      setAutoFillData(res);
    });
  }, []);

  useEffect(() => {
    if (autoFillData !== undefined) {
      let start_date = autoFillData["start_date"][dataset];
      let end_date = autoFillData["end_date"][dataset];

      let start_date_obj = new Date(start_date);
      let end_date_obj = new Date(end_date);

      setStartDate(start_date_obj);
      setMinDate(start_date_obj);
      setEndDate(end_date_obj);
      setMaxDate(end_date_obj);
    }
  }, [autoFillData]);

  useEffect(() => {
    if (document !== null) {
      document.getElementById("floatingSelectDataset").selectedIndex = 1;
      let DatasetValue = document.getElementById("floatingSelectDataset").value;
      console.log("selectedDatasetValue", DatasetValue);
      setDataset(DatasetValue);

      if (autoFillData !== undefined) {
        let start_date_obj = new Date(autoFillData["start_date"][DatasetValue]);
        let end_date_obj = new Date(autoFillData["end_date"][DatasetValue]);

        setStartDate(start_date_obj);
        setMinDate(start_date_obj);
        setEndDate(end_date_obj);
        setMaxDate(end_date_obj);
      }

      let temp = optionSelected;
      temp.dataset_name = DatasetValue;
      setOptionSelected(temp);
    }
  }, [task]);

  useEffect(() => {
    if (document !== null) {
      document.getElementById("floatingSelectAlgorithm").selectedIndex = 1;
      let algorithmValue = document.getElementById(
        "floatingSelectAlgorithm"
      ).value;
      console.log("selectedAlgorithmValue", algorithmValue);
      setAgent(algorithmValue);

      let temp = optionSelected;
      temp.agent_name = algorithmValue;
      setOptionSelected(temp);
    }
  }, [dataset]);

  const notifyToast = (text, type) => {
    if (type == "success") {
      toast.success(text);
    } else if (type == "error") {
      toast.error(text);
    } else if (type == "info") {
      toast.info(text);
    }
  };

  const autoFillParameters = () => {
    // autofill other parameters
    let temp = optionSelected;
    temp.optimizer_name = autoFillData["optimizer_name"][0];
    temp.loss_name = autoFillData["loss_name"][0];
    switch (temp.dataset_name) {
      case "algorithmic_trading:BTC":
        temp.start_date = autoFillData["start_date"]["algorithmic_trading:BTC"];
        temp.end_date = autoFillData["end_date"]["algorithmic_trading:BTC"];
        break;

      case "algorithmic_trading:FX":
        temp.start_date = autoFillData["start_date"]["algorithmic_trading:FX"];
        temp.end_date = autoFillData["end_date"]["algorithmic_trading:FX"];
        break;

      case "order_excecution:BTC":
        temp.start_date = autoFillData["start_date"]["order_excecution:BTC"];
        temp.end_date = autoFillData["end_date"]["order_excecution:BTC"];
        break;

      case "order_excecution:PD_BTC":
        temp.start_date = autoFillData["start_date"]["order_excecution:PD_BTC"];
        temp.end_date = autoFillData["end_date"]["order_excecution:PD_BTC"];
        break;

      case "portfolio_management:dj30":
        temp.start_date =
          autoFillData["start_date"]["portfolio_management:dj30"];
        temp.end_date = autoFillData["end_date"]["portfolio_management:dj30"];
        break;

      case "portfolio_management:exchange":
        temp.start_date =
          autoFillData["start_date"]["portfolio_management:exchange"];
        temp.end_date =
          autoFillData["end_date"]["portfolio_management:exchange"];
        break;
    }

    setOptionSelected(temp);
    console.log("BEFORE SEND", optionSelected);
  };

  async function trainStatusloop(sessionID) {
    let trainEnd = false;
    while (trainEnd === false) {
      await new Promise((resolve) => setTimeout(resolve, 10000));
      // do something here
      // test-status request
      let promise2 = trainStatusRequest(sessionID);
      notifyToast(
        "Train Status Request submitted! Please be patient...",
        "info"
      );
      promise2
        // eslint-disable-next-line no-loop-func
        .then((res) => {
          console.log("trainStatusRequest", res);
          let newStr = res.info;
          setRequestTrainOutput(newStr);
          if (res.train_end === true) {
            setFigure1Base64String(res.result_plot);
            trainEnd = true;
          }
          notifyToast(
            "Train Status Response Received! Output Updated. Please be patient..., the Training is still running...",
            "success"
          );
        })
        .catch((error) => {
          console.log("error", error);
          notifyToast(error, "error");
        });
    }

    // testRequest
    let promise3 = testRequest(sessionID);
    notifyToast("Test Request submitted! Please be patient...", "info");
    promise3
      .then((res) => {
        console.log("testRequest", res);
        let newStr = res.info;
        setRequestTestOutput(newStr);
        notifyToast("Test Response Received! Output Updated", "success");
        testStatusloop(sessionID);
      })
      .catch((error) => {
        console.log("error", error);
        notifyToast(error, "error");
      });
  }

  async function testStatusloop(sessionID) {
    let testEnd = false;
    while (testEnd === false) {
      await new Promise((resolve) => setTimeout(resolve, 10000));
      // do something here
      // test-status request
      let promise2 = testStatusRequest(sessionID);
      notifyToast(
        "Train Status Request submitted! Please be patient...",
        "info"
      );
      promise2
        // eslint-disable-next-line no-loop-func
        .then((res) => {
          console.log("testStatusRequest", res);
          let newStr = res.info;
          setRequestTestOutput(newStr);
          if (res.test_end === true) {
            setFigure2Base64String(res.result_plot);
            testEnd = true;
          }
          notifyToast(
            "Test Status Response Received! Output Updated. Please be patient..., the Test is still running...",
            "success"
          );
        })
        .catch((error) => {
          console.log("error", error);
          notifyToast(error, "error");
        });
    }
  }

  const trainOnClick = () => {
    if (sessionID !== "") {
      // eslint-disable-next-line no-restricted-globals
      let result = confirm(
        "Do you want to train? It will create a new session"
      );
      if (result === false) {
        return;
      }
    }

    autoFillParameters();

    let promise = trainRequest(optionSelected);
    promise
      .then((res) => {
        setSessionID(res.session_id);
        let newStr = res.info;
        setRequestTrainOutput(newStr);
        notifyToast("Train Response Received! Output Updated", "success");

        trainStatusloop(res.session_id);
      })
      .catch((error) => {
        console.log("error", error);
        notifyToast(error, "error");
      });
  };

  const createDatasetOptions = () => {
    if (task == "algorithmic_trading") {
      const tempOptions1 = (
        <>
          <option value=""></option>
          <option value="algorithmic_trading:BTC">Bitcoin</option>
          {/* <option value="algorithmic_trading:FX">
            Foreign Exchange(CNY/USD)
          </option>
          <option value="algorithmic_trading:JPM">Stock(JPM)</option> */}
        </>
      );
      return tempOptions1;
    }
    // else if (task == "order_execution") {
    //   const tempOptions2 = (
    //     <>
    //       <option value=""></option>
    //       {/*<option value="order_execution:BTC">Bitcoin (Minute-level)</option>*/}
    //       <option value="order_execution:PD_BTC">Bitcoin (Day-level)</option>
    //     </>
    //   );
    //   return tempOptions2;
    // }
    else if (task == "portfolio_management") {
      const tempOptions3 = (
        <>
          <option value=""></option>
          <option value="portfolio_management:dj30">Dow Jones 30 Stocks</option>
          <option value="portfolio_management:exchange">
            Foreign Exchange
          </option>
        </>
      );
      return tempOptions3;
    }
  };

  const createAgentNameOptions = () => {
    if (
      dataset == "algorithmic_trading:BTC" ||
      dataset == "algorithmic_trading:FX" ||
      dataset == "algorithmic_trading:JPM"
    ) {
      const tempOptions1 = (
        <>
          <option value=""></option>
          <option value="algorithmic_trading:deepscalper">Deepscalper</option>
        </>
      );
      return tempOptions1;
    } else if (dataset == "order_execution:BTC") {
      const tempOptions2 = (
        <>
          <option value=""></option>
          <option value="order_execution:eteo">ETEO</option>
        </>
      );
      return tempOptions2;
    } else if (dataset == "order_execution:PD_BTC") {
      const tempOptions3 = (
        <>
          <option value=""></option>
          <option value="order_execution:pd">OPD</option>
        </>
      );
      return tempOptions3;
    } else if (dataset == "portfolio_management:dj30") {
      const tempOptions4 = (
        <>
          <option value=""></option>
          <option value="portfolio_management:eiie">EIIE</option>
          <option value="portfolio_management:investor_imitator">
            Investor-Imitator
          </option>
          <option value="portfolio_management:sarl">SARL</option>
        </>
      );
      return tempOptions4;
    } else if (dataset == "portfolio_management:exchange") {
      const tempOptions5 = (
        <>
          <option value=""></option>
          <option value="portfolio_management:a2c">A2C</option>
          <option value="portfolio_management:ddpg">DDPG</option>
          <option value="portfolio_management:pg">Policy Gradient</option>
          <option value="portfolio_management:ppo">PPO</option>
          <option value="portfolio_management:sac">SAC</option>
          <option value="portfolio_management:td3">TD3</option>
        </>
      );
      return tempOptions5;
    }
  };

  const setTrainBtnDisabledTimer = () => {
    setTimeout(() => {
      setTrainBtnDisabled(false);
    }, 30000);
  };

  return (
    <div>

      <div style={{ marginTop: '-30px', textAlign: 'center' }}>
        <div className="main1">
          Train and Test Your RL QT Agent with One Button
        </div>
      </div>



      <div className="buzhou2" style={{ marginTop: '40px' }}>
        <div className="se1">

          <div className="row">
            <div className="col my-2"></div>
          </div>

          <div className="form-floating">

            <div className="word13">{'\u2460'} Setup the Experiment</div>
          </div>

          <div className="row">
            <div className="col my-2">
              <div>
                <div className="seatIP">Task</div>
                <select
                  className="form-select"
                  id="floatingSelect"
                  style={{ marginTop: '10px' }}
                  onChange={(e) => {
                    setTask(e.target.value);
                    var temp = optionSelected;
                    temp.task_name = e.target.value;

                    if (e.target.value === "algorithmic_trading") {
                      temp.dataset_name = "";
                      temp.agent_name = "";
                    } else if (e.target.value === "order_execution") {
                      temp.dataset_name = "";
                      temp.agent_name = "";
                    } else if (e.target.value === "portfolio_management") {
                      temp.dataset_name = "";
                      temp.agent_name = "";
                    }
                    setDataset("");
                    setAgent("");
                    console.log("temp", temp);
                    setOptionSelected(temp);
                  }}
                >
                  <option value="algorithmic_trading">Algorithmic Trading</option>
                  {/*<option value="order_execution">Order Execution</option>*/}
                  <option value="portfolio_management">Portfolio Management</option>
                </select>

              </div>
            </div>

            <div className="col my-2">
              <div className="">
                <div className="seatIP">Dataset</div>
                <select
                  className="form-select"
                  id="floatingSelectDataset"
                  style={{ marginTop: '10px' }}
                  onChange={(e) => {
                    setDataset(e.target.value);
                    let temp = optionSelected;
                    temp.dataset_name = e.target.value;
                    console.log("temp", temp);
                    setOptionSelected(temp);

                    if (e.target.value !== "") {
                      let start_date_obj = new Date(
                        autoFillData["start_date"][e.target.value]
                      );
                      let end_date_obj = new Date(
                        autoFillData["end_date"][e.target.value]
                      );

                      setStartDate(start_date_obj);
                      setMinDate(start_date_obj);
                      setEndDate(end_date_obj);
                      setMaxDate(end_date_obj);
                    }
                  }}
                >
                  {createDatasetOptions()}
                </select>
              </div>
            </div>

            <div className="col my-2">
              <div className="">
                <div className="seatIP">Algorithm</div>
                <select
                  className="form-select"
                  id="floatingSelectAlgorithm"
                  style={{ marginTop: '10px' }}
                  onChange={(e) => {
                    setAgent(e.target.value);
                    let temp = optionSelected;
                    temp.agent_name = e.target.value;
                    console.log("temp", temp);
                    setOptionSelected(temp);
                  }}
                >
                  {createAgentNameOptions()}
                </select>
              </div>
            </div>

            <div className="row">
              <div className="offset-4 col-4">
                <button
                  className="btn btn-primary"
                  type="button"

                  data-bs-toggle="collapse"
                  data-bs-target="#collapseExample"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                  style={{ width: "100%", fontSize: "16px", marginTop: '30px', height: '60px' }}
                >
                  Advanced Parameters <span className="caret"></span>
                </button>
              </div>
            </div>

            <div className="collapse" id="collapseExample" style={{ marginTop: '20px', marginBottom: '20px' }}>
              <div className="row my-2">
                <div className="col">
                  <div>
                    <div className="seatIP">Optimizer Name</div>
                    <select
                      style={{ marginTop: '10px' }}
                      className="form-select"
                      id="floatingSelectAlgorithm"
                      onChange={(e) => {
                        setOptimizerName(e.target.value);
                        let temp = optionSelected;
                        temp.optimizer_name = e.target.value;
                        console.log("temp", temp);
                        setOptionSelected(temp);
                      }}
                    >
                      <option value=""></option>
                      <option value="adam" selected>
                        Adam
                      </option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div>
                    <div className="seatIP">Loss Name</div>
                    <select
                      className="form-select"
                      style={{ marginTop: '10px' }}
                      id="floatingSelectAlgorithm"
                      onChange={(e) => {
                        setLossName(e.target.value);
                        let temp = optionSelected;
                        temp.loss_name = e.target.value;
                        console.log("temp", temp);
                        setOptionSelected(temp);
                      }}
                    >
                      <option value=""></option>
                      <option value="mse" selected>
                        MSE
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="seatIP">Start Date</div>
                  <DatePicker
                    className="datepicker"
                    id="testDatePicker"
                    dateFormat="yyyy-MM-dd"
                    style={{ marginTop: '10px' }}
                    placeholderText="YYYY-MM-DD"
                    selected={startDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    onChange={(date) => {
                      setStartDate(date);
                      let temp = optionSelected;
                      temp.start_date = getDateStrFromDate(date);
                      console.log("temp", temp);
                      setOptionSelected(temp);
                    }}
                  />
                </div>
                <div className="col">
                  <div className="seatIP">End Date</div>
                  <DatePicker
                    className="datepicker"
                    id="testDatePicker"
                    dateFormat="yyyy-MM-dd"
                    placeholderText="YYYY-MM-DD"
                    selected={endDate}
                    minDate={minDate}
                    maxDate={maxDate}
                    onChange={(date) => {
                      setEndDate(date);
                      let temp = optionSelected;
                      temp.end_date = getDateStrFromDate(date);
                      console.log("temp", temp);
                      setOptionSelected(temp);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-5">
        <div className="offset-4 col-4 button-col">
          <Button
            disabled={trainBtnDisabled}
            type="primary"
            onClick={() => {
              if (dataset == "" || agent == "") {
                notifyToast(
                  "Please select a dataset and Algorithm first!",
                  "error"
                );
                return;
              }

              notifyToast(
                "Train Request submitted! Please be patient...",
                "info"
              );
              setRequestTrainOutput("");
              setRequestTestOutput("");
              setFigure1Base64String("");
              setFigure1Url("");
              setFigure2Base64String("");
              setFigure2Url("");
              setTrainBtnDisabled(true);
              // setTrainBtnDisabledTimer();
              console.log("optionSelected", optionSelected);
              trainOnClick();
            }}
          >
            {'\u2461'} Train
          </Button>
        </div>
        

        <div className="errorTiips">
        <p
          className="offset-4 col-4 "
          style={{ fontSize: "18px", textAlign: "center", fontWeight: 700,marginTop:'30px',}}
        >
          {trainBtnDisabled
            ? (
              <>
                1. The training process may take <span style={{ color: "red" }}> a few minutes </span> for each update.
              </>)
            : ("")}
        </p>
        <p
          className="offset-4 col-4"
          style={{ fontSize: "18px", textAlign: "center", fontWeight: 700 }}
        >
          {trainBtnDisabled ? (
            <>
              2. If you want to start a new session, please <span style={{ color: "red" }}>refresh</span> the page.
            </>
          ) : (
            ""
          )}
        </p>
        </div>
      </div>


      <div style={{ width: '1200px', margin: '0 auto' }}>
        <div className="row my-2">
          <div className="col-6 form-floating word5">
            <h3>{'\u2462'} Training Result</h3>
          </div>
          <div className="col-6 form-floating word5">
            <h3>{'\u2464'} Testing Result</h3>
          </div>
        </div>




        <div className="row my-2">
          <div className="col-6">
            <div className="form-floating">
              <pre className="output-container_service">{requestTrainOutput}</pre>
            </div>
          </div>
          <div className="col-6">
            <div className="form-floating">
              <pre className="output-container_service">{requestTestOutput}</pre>
            </div>
          </div>
        </div>

        <div className="row my-2" style={{ width: '1200px', margin: '0 auto' }}>
          <div className="col-6 form-floating word5">
            <h3>{'\u2463'} Training Visualization </h3>
          </div>
          <div className="col-6 form-floating word5">
            <h3>{'\u2465'} Testing Visualization</h3>
          </div>
        </div>
        <div className="row my-2">
          <div className="col-6">
            <div className="card custom-card">
              <div className="card-body">

                {figure1Url !== "" ? (
                  <img
                    src={figure1Url}
                    alt="result_plot1"
                    className="img-fluid zoomed"
                  />
                ) : (
                  <div className="placeholder-content"> </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="card custom-card">
              <div className="card-body">
                {figure2Url !== "" ? (
                  <img
                    src={figure2Url}
                    alt="result_plot2"
                    className="img-fluid zoomed"
                  />
                ) : (
                  <div className="placeholder-content"> </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>


      {/*<div className="row my-2">*/}
      {/*  <div className="col-6">*/}
      {/*    {figure1Url !== "" && (*/}
      {/*      <div className="card">*/}
      {/*        <div className="card-body">*/}
      {/*          <img*/}
      {/*            src={figure1Url}*/}
      {/*            alt="result_plot1"*/}
      {/*            className="img-fluid"*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*  <div className="col-6">*/}
      {/*    {figure2Url !== "" && (*/}
      {/*      <div className="card">*/}
      {/*        <div className="card-body">*/}
      {/*          <img*/}
      {/*            src={figure2Url}*/}
      {/*            alt="result_plot2"*/}
      {/*            className="img-fluid"*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*</div>*/}


      <div style={{ marginTop: '-30px', textAlign: 'center' }}>
        <div className="main1">
        You may continue to evaluate your agent after testing is done
        </div>
      </div>
      <div className="row my-2">
        <div className="col-6 offset-3 form-floating" style={{marginTop:'30px',marginBottom:'80px'}}>
          <Button
            type="primary"
            style={{color:'#fff'}}
            onClick={() => navigate("/evaluation-toolbox")}
          >
            {'\u2466'} Evaluate Your Agent{" "}
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
          </Button>
        </div>
      </div>

      {/*<div className="row my-2">*/}
      {/*  <div className="col-6">*/}
      {/*    {figure1Url !== "" && (*/}
      {/*      <img src={figure1Url} alt="result_plot1" className="img-fluid" />*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*  <div className="col-6">*/}
      {/*    {figure2Url !== "" && (*/}
      {/*      <img src={figure2Url} alt="result_plot2" className="img-fluid" />*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*</div>*/}

      <ToastContainer />
    </div>
  );
}
